const actions = {
  SET_STATE: 'statements/SET_STATE',
  SET_CURRENT_ACCOUNT: 'statements/SET_CURRENT_ACCOUNT',
  FETCH_STATEMENTS_OVERVIEW: 'statements/FETCH_STATEMENTS_OVERVIEW',
  FETCH_ACCOUNT_GROWTH: 'statements/FETCH_ACCOUNT_GROWTH',
  FETCH_STATEMENTS_DETAIL: 'statements/FETCH_STATEMENTS_DETAIL'
}

export default actions
